<div class="organizer-shared-layout-funnel container">
  <header
    class="organizer-shared-layout-funnel__header container 2xl:max-w-none"
    [class.organizer-shared-layout-funnel__header--dark]="isDarkMode"
    [class.organizer-shared-layout-funnel__header--light]="isLightMode"
  >
    <app-logo
      class="organizer-shared-layout-funnel__header__logo"
      [name]="logoType"
      [height]="logoHeight"
    ></app-logo>

    <ng-content select="[layout-right-content]"></ng-content>

    <button
      *ngIf="hasCloseButton"
      app-cta
      type="button"
      class="organizer-shared-layout-funnel__button"
      [variant]="buttonVariant"
      (click)="showModal()"
    >
      <vtmn-play-icon
        [name]="iconName"
        [ariaLabel]="leaveModalConfig.labelKey | translate"
        [class.text-white]="isLightMode"
      ></vtmn-play-icon>
      <span class="organizer-shared-layout-funnel__button__label">
        {{ leaveModalConfig.labelKey | translate }}
      </span>
    </button>
  </header>
  <main class="organizer-shared-layout-funnel__content col-span-12">
    <ng-content></ng-content>
  </main>
  <app-alert-modal
    [confirmLabel]="
      'shared_organizer.layout.header.modal.footer.confirm' | translate
    "
    [closeLabel]="
      'shared_organizer.layout.header.modal.footer.close' | translate
    "
    (modalClose)="closeModal()"
    (modalConfirm)="leave()"
    [hasCloseButton]="true"
    [autoClose]="true"
  >
    <div modal-header>
      {{ leaveModalConfig.headerKey | translate }}
    </div>
    <div modal-content>
      {{ leaveModalConfig.contentKey | translate }}
    </div>
  </app-alert-modal>
</div>
